import type { Permission } from "@@/shared/auth/scopes/permission";
import {
    isoAndUnixZodSchema,
    nowIsoAndUnix,
    type IsoAndUnixTimestamp,
} from "@@/shared/date-time/iso-and-unix";
import { idZodSchema } from "@@/shared/id";
import {
    providerIdZodSchema,
    type ProviderId,
} from "@@/shared/providers/provider-id";
import { generateId } from "@@/utilities/generate-id";
import type { Except } from "type-fest";
import { z } from "zod";

type CreateInvitationCommand = {
    readonly _id: string;
    readonly _type: "CREATE_INVITATION_COMMAND";
    readonly _createdAt: IsoAndUnixTimestamp;

    readonly providerId: ProviderId;
    readonly email: string;
    readonly permission: Permission;
};

type FactoryParams = Except<
    CreateInvitationCommand,
    "_id" | "_type" | "_createdAt"
>;
const createInvitationCommandFactory = (params: FactoryParams) => {
    const command: CreateInvitationCommand = {
        ...params,
        _id: generateId({ prefix: "create_invitation_command__" }),
        _type: "CREATE_INVITATION_COMMAND",
        _createdAt: nowIsoAndUnix(),
    };
    return command;
};

const invitationCreateCommandScheme: z.ZodSchema<CreateInvitationCommand> =
    z.object({
        _id: idZodSchema,
        _type: z.literal("CREATE_INVITATION_COMMAND"),
        _createdAt: isoAndUnixZodSchema,
        providerId: providerIdZodSchema,
        email: z.string(),
        permission: z.union([
            z.literal("read"),
            z.literal("write"),
            z.literal("owner"),
        ]),
    });

export { createInvitationCommandFactory, invitationCreateCommandScheme };
export type {
    CreateInvitationCommand,
    FactoryParams as CreateInvitationCommandParams,
};
